// HistorialComportamientoReportesOperadores.jsx
import React, { useEffect, useMemo, useState, useContext } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  CircularProgress,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import GeneralContext from "../GeneralContext/GeneralContext";

import PageBody from "../GeneralComponents/PageBody";
import InputFilter from "../GeneralComponents/InputFilter";

import axios from "../../api/axios";

const dumydata = {
  ok: true,
  total_fuentes: 3,
  total_operadores: 33,
  fuentes: [
    {
      fuente: "vw_control_parental",
      total_operadores: 11,
      operadores: [
        {
          nombre_operador: "CHILE TV CABLE S.A.",
          periodos_presentes: [
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
          ],
          periodos_faltantes: [
            "2025-01-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 10,
          total_faltantes: 14,
        },
        {
          nombre_operador: "ELECTRONET S.A.",
          periodos_presentes: [],
          periodos_faltantes: [
            "2025-01-01",
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 0,
          total_faltantes: 24,
        },
        {
          nombre_operador: "GTD MANQUEHUE S.A.",
          periodos_presentes: [
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
          ],
          periodos_faltantes: [
            "2025-01-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 9,
          total_faltantes: 15,
        },
        {
          nombre_operador: "INGBELL CHILE SPA",
          periodos_presentes: [
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
          ],
          periodos_faltantes: [
            "2025-01-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 10,
          total_faltantes: 14,
        },
        {
          nombre_operador: "LUZLINARES S.A.",
          periodos_presentes: [],
          periodos_faltantes: [
            "2025-01-01",
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 0,
          total_faltantes: 24,
        },
        {
          nombre_operador: "LUZPARRAL S.A.",
          periodos_presentes: [],
          periodos_faltantes: [
            "2025-01-01",
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 0,
          total_faltantes: 24,
        },
        {
          nombre_operador: "MI INTERNET SPA",
          periodos_presentes: [
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
          ],
          periodos_faltantes: [
            "2025-01-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 10,
          total_faltantes: 14,
        },
        {
          nombre_operador: "NETLAND CHILE S.A.",
          periodos_presentes: ["2025-08-01", "2025-09-01", "2025-10-01", "2025-11-01"],
          periodos_faltantes: [
            "2025-01-01",
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 4,
          total_faltantes: 20,
        },
        {
          nombre_operador: "TELEFONICA EMPRESAS CHILE S.A.",
          periodos_presentes: ["2025-02-01"],
          periodos_faltantes: [
            "2025-01-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 1,
          total_faltantes: 23,
        },
        {
          nombre_operador: "TEXUS NETWORKS SPA.",
          periodos_presentes: [],
          periodos_faltantes: [
            "2025-01-01",
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 0,
          total_faltantes: 24,
        },
        {
          nombre_operador: "VTR COMUNICACIONES SPA.",
          periodos_presentes: [
            "2025-02-01",
            "2025-03-01",
            "2025-04-01",
            "2025-05-01",
            "2025-06-01",
            "2025-07-01",
            "2025-08-01",
            "2025-09-01",
            "2025-10-01",
            "2025-11-01",
          ],
          periodos_faltantes: [
            "2025-01-01",
            "2025-12-01",
            "2026-01-01",
            "2026-02-01",
            "2026-03-01",
            "2026-04-01",
            "2026-05-01",
            "2026-06-01",
            "2026-07-01",
            "2026-08-01",
            "2026-09-01",
            "2026-10-01",
            "2026-11-01",
            "2026-12-01",
          ],
          total_presentes: 10,
          total_faltantes: 14,
        },
      ],
    },
    { fuente: "vw_dominios_interes_mineduc", total_operadores: 11, operadores: [] },
    { fuente: "vw_maliciosas", total_operadores: 11, operadores: [] },
  ],
};

// =====================
// UI constants/helpers
// =====================
const MONTHS = [
  { key: "01", label: "Enero" },
  { key: "02", label: "Febrero" },
  { key: "03", label: "Marzo" },
  { key: "04", label: "Abril" },
  { key: "05", label: "Mayo" },
  { key: "06", label: "Junio" },
  { key: "07", label: "Julio" },
  { key: "08", label: "Agosto" },
  { key: "09", label: "Septiembre" },
  { key: "10", label: "Octubre" },
  { key: "11", label: "Noviembre" },
  { key: "12", label: "Diciembre" },
];

// Anchos FIJOS
const OP_COL_W = 320;
const MONTH_COL_W = 140;

const monthKey = (d) => String(d).slice(0, 7); // "YYYY-MM"
const yearOf = (d) => Number(String(d).slice(0, 4));
const monthsOfYear = (year) => MONTHS.map((m) => `${year}-${m.key}`);

const CURRENT_YEAR = new Date().getFullYear();
function buildYearRange(from = 2025, to = CURRENT_YEAR) {
  const out = [];
  for (let y = from; y <= to; y++) out.push(y);
  return out;
}

function dotColor(present, total) {
  if (!total) return "#bdbdbd";
  if (present === 0) return "#e53935";
  if (present < total) return "#fb8c00";
  return "#43a047";
}

// =====================
// Data helpers
// =====================
function buildPresenceIndex(apiData) {
  const byFuente = new Map();

  (apiData?.fuentes ?? []).forEach((f) => {
    const byOper = new Map();
    (f.operadores ?? []).forEach((op) => {
      const set = new Set((op.periodos_presentes ?? []).map(monthKey));
      byOper.set(op.nombre_operador, set);
    });
    byFuente.set(f.fuente, byOper);
  });

  return byFuente;
}

function extractYears(apiData) {
  const years = new Set();
  (apiData?.fuentes ?? []).forEach((f) => {
    (f.operadores ?? []).forEach((op) => {
      (op.periodos_presentes ?? []).forEach((p) => years.add(yearOf(p)));
      (op.periodos_faltantes ?? []).forEach((p) => years.add(yearOf(p)));
    });
  });
  return Array.from(years).filter(Boolean).sort((a, b) => b - a);
}

function buildGrid({ apiData, selectedYear, selectedFuente = "ALL" }) {
  const idx = buildPresenceIndex(apiData);

  const fuentes =
    selectedFuente === "ALL" ? Array.from(idx.keys()) : [selectedFuente].filter((x) => idx.has(x));

  const opsSet = new Set();
  fuentes.forEach((fu) => {
    const mapOp = idx.get(fu);
    if (mapOp) Array.from(mapOp.keys()).forEach((name) => opsSet.add(name));
  });
  const operadores = Array.from(opsSet).sort((a, b) => a.localeCompare(b));

  const months = monthsOfYear(selectedYear);
  const total = fuentes.length;

  const rows = operadores.map((opName) => {
    const cells = months.map((ym) => {
      let present = 0;
      fuentes.forEach((fu) => {
        const set = idx.get(fu)?.get(opName);
        if (set?.has(ym)) present += 1;
      });
      return { ym, present, total };
    });

    return { operador: opName, cells };
  });

  return { idx, fuentes, months, rows };
}

export default function HistorialReportes() {
  const { pageTitle, setPageTitle } = useContext(GeneralContext);

  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState(null);

  const [selectedFuente, setSelectedFuente] = useState("ALL");
  const [selectedOperador, setSelectedOperador] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  const [expandedOps, setExpandedOps] = useState(() => new Set());

  const yearButtons = useMemo(() => {
    const ys = buildYearRange(2025, CURRENT_YEAR);
    return ys.sort((a, b) => b - a);
  }, []);

  useEffect(() => {
    let alive = true;

    const load = async () => {
      try {
        setLoading(true);
        // const resp = await axios.getHistorialReportes?.();
        // const data = resp?.data ?? resp;
        const data = dumydata;

        if (!alive) return;

        setApiData(data);

        // toma el más reciente disponible, si no fallback al current
        const yearsFromData = extractYears(data);
        const y0 = yearsFromData?.find((y) => y >= 2025 && y <= CURRENT_YEAR) ?? CURRENT_YEAR;

        setSelectedYear(y0);
        setSelectedFuente("ALL");
        setSelectedOperador(null);
        setExpandedOps(new Set());
      } catch (e) {
        if (!alive) return;
        console.error("Error cargando historial:", e);
        setApiData(null);
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();
    return () => {
      alive = false;
    };
  }, []);

  const reportOptions = useMemo(() => {
    const f = (apiData?.fuentes ?? []).map((x) => x.fuente);
    return ["ALL", ...Array.from(new Set(f)).sort((a, b) => a.localeCompare(b))];
  }, [apiData]);

  const grid = useMemo(() => {
    if (!apiData || !selectedYear) return { idx: new Map(), fuentes: [], months: [], rows: [] };
    return buildGrid({ apiData, selectedYear, selectedFuente });
  }, [apiData, selectedYear, selectedFuente]);

  const operatorOptions = useMemo(() => grid.rows.map((r) => r.operador), [grid.rows]);

  const visibleRows = useMemo(() => {
    if (!selectedOperador) return grid.rows;
    return grid.rows.filter((r) => r.operador === selectedOperador);
  }, [grid.rows, selectedOperador]);

  const toggleExpand = (opName) => {
    setExpandedOps((prev) => {
      const next = new Set(prev);
      if (next.has(opName)) next.delete(opName);
      else next.add(opName);
      return next;
    });
  };

  const collapseAllOps = () => setExpandedOps(new Set());
  const expandAllOps = () => setExpandedOps(new Set(visibleRows.map((r) => r.operador)));

  const isAllExpanded = useMemo(() => {
    if (!visibleRows.length) return false;
    return visibleRows.every((r) => expandedOps.has(r.operador));
  }, [visibleRows, expandedOps]);

  const handleYearSelect = (y) => {
    setSelectedYear(y);
    setExpandedOps(new Set());
  };

  const handleFilter = (item, value) => {
    if (item === "reporte") {
      setSelectedFuente(value ?? "ALL");
      setExpandedOps(new Set());
      return;
    }
    if (item === "operador") {
      setSelectedOperador(value ?? null);
      setExpandedOps(new Set());
      return;
    }
  };

  const detailRowsForOperator = (opName) => {
    if (selectedFuente !== "ALL") return [];

    const fuentes = Array.from(grid.idx.keys()).sort((a, b) => a.localeCompare(b));
    const months = grid.months;

    return fuentes.map((fuente) => {
      const set = grid.idx.get(fuente)?.get(opName) ?? new Set();
      const cells = months.map((ym) => ({
        ym,
        present: set.has(ym) ? 1 : 0,
        total: 1,
      }));
      return { fuente, cells };
    });
  };

  useEffect(() => {
    setPageTitle("Listado histórico de pre-facturas");
  }, [pageTitle, setPageTitle]);

  const tableFixedSx = {
    tableLayout: "fixed",
    width: OP_COL_W + MONTH_COL_W * 12,
    "& th, & td": { boxSizing: "border-box", mx: 0 },
  };

  const monthCellSx = { width: MONTH_COL_W, minWidth: MONTH_COL_W };

  const stickyFirstColBodySx = {
    width: OP_COL_W,
    minWidth: OP_COL_W,
    position: "sticky",
    left: 0,
    zIndex: 3, 

    bgcolor: "background.paper",
  };

  const stickyFirstColHeadSx = {
    ...stickyFirstColBodySx,
    zIndex: 4,
    bgcolor: "background.paper",
  };

  const yearColSize = useMemo(() => {
    const n = yearButtons.length || 1;
    return Math.max(2, Math.floor(12 / n));
  }, [yearButtons.length]);


  const expandedRowSx = {
    backgroundColor: "#B0C9E2!important",
  };

  return (
    <PageBody>
      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Stack spacing={1} alignItems="center">
            <Typography sx={{ fontWeight: 800, letterSpacing: 0.5, textAlign: "center" }}>
              HISTORIAL DE COMPORTAMIENTO REPORTES DE OPERADORES
            </Typography>

            {/* FILTROS (GRID 1) */}
            <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5, width: "100%" }}>
              <Grid item size={{ xs: 12, md: 6 }}>
                <InputFilter
                  item="reporte"
                  name="Reporte"
                  data={[]}
                  opt={reportOptions}
                  defaultOpt={["ALL"]}
                  value={selectedFuente}
                  callback={handleFilter}
                  disabled={!apiData || loading}
                />
              </Grid>

              <Grid item size={{ xs: 12, md: 6 }}>
                <InputFilter
                  item="operador"
                  name="Operador"
                  data={[]}
                  opt={operatorOptions}
                  defaultOpt={[]}
                  value={selectedOperador}
                  callback={handleFilter}
                  disabled={!apiData || loading}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center" sx={{ mt: 0.5, width: "100%" }}>
              {yearButtons.map((y) => {
                const active = selectedYear === y;
                const showCollapseInside = active && selectedFuente === "ALL";

                return (
                  <Grid key={y} item size={{ xs: 12, sm: yearColSize, md: yearColSize }}>
                    <Button
                      fullWidth
                      onClick={() => handleYearSelect(y)}
                      variant={active ? "contained" : "outlined"}
                      disabled={!apiData || loading}
                      sx={{ justifyContent: "space-between", gap: 1, textTransform: "none" }}
                    >
                      <span>{y}</span>

                      {showCollapseInside ? (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isAllExpanded) collapseAllOps();
                            else expandAllOps();
                          }}
                          sx={{ p: 0.25, ml: 0.5 }}
                        >
                          {isAllExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                        </IconButton>
                      ) : (
                        <Box sx={{ width: 28 }} />
                      )}
                    </Button>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </Paper>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress />
          </Box>
        ) : !apiData ? (
          <Paper sx={{ p: 4, textAlign: "center", color: "text.secondary" }}>
            Sin datos
          </Paper>
        ) : (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small" stickyHeader sx={tableFixedSx}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...stickyFirstColHeadSx, fontWeight: 700 }}>Operador</TableCell>
                  {MONTHS.map((m) => (
                    <TableCell key={m.key} align="center" sx={{ ...monthCellSx, fontWeight: 700 }}>
                      {m.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {visibleRows.map((r) => {
                  const allowExpand = selectedFuente === "ALL";
                  const isExpanded = expandedOps.has(r.operador);
                  const detailRows = allowExpand ? detailRowsForOperator(r.operador) : [];

                  return (
                    <React.Fragment key={r.operador}>
                      <TableRow  sx={isExpanded ? expandedRowSx : "background.paper"}>
                        <TableCell sx={{ ...stickyFirstColBodySx, fontWeight: 700, bgcolor: isExpanded ? expandedRowSx : "background.paper"  }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            {allowExpand ? (
                              <IconButton size="small" onClick={() => toggleExpand(r.operador)}>
                                {isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                              </IconButton>
                            ) : (
                              <Box sx={{ width: 34 }} />
                            )}
                            <span>{r.operador}</span>
                          </Stack>
                        </TableCell>

                        {r.cells.map((c) => (
                          <TableCell key={c.ym} align="center" sx={monthCellSx}>
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                              <Box
                                sx={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "999px",
                                  bgcolor: dotColor(c.present, c.total),
                                }}
                              />
                              <Typography component="span" sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
                                {c.present}/{c.total}
                              </Typography>
                            </Box>
                          </TableCell>
                        ))}
                      </TableRow>

                      {allowExpand ? (
                        <TableRow>
                          <TableCell colSpan={13} sx={{ p: 0, border: 0 }}>
                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                              <Table size="small" sx={tableFixedSx}>
                                <TableBody>
                                  {detailRows.map((d) => (
                                    <TableRow key={d.fuente} hover>
                                      <TableCell sx={{ ...stickyFirstColBodySx, px: 4 }}>
                                        <Typography sx={{ fontSize: "0.86rem", fontWeight: 700 }}>
                                          {d.fuente}
                                        </Typography>
                                      </TableCell>

                                      {d.cells.map((c) => (
                                        <TableCell key={c.ym} align="center" sx={monthCellSx}>
                                          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                                            <Box
                                              sx={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: "999px",
                                                bgcolor: dotColor(c.present, c.total),
                                              }}
                                            />
                                            <Typography component="span" sx={{ fontSize: "0.82rem", fontWeight: 600 }}>
                                              {c.present === 0 ? "-" : c.ym}
                                            </Typography>
                                          </Box>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      ) : null}
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </PageBody>
  );
}
